"use strict"
exports.__esModule = true;
exports.TapeIconConfig = {
  name: 'TapeIcon',
  height: 512,
  width: 640,
  svgPath: 'M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z',
  yOffset: 0,
  xOffset: 0,
};
exports.TapeIcon = require('../createIcon').createIcon(exports.TapeIconConfig);
exports["default"] = exports.TapeIcon;